<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>{{TitleHeader}}</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono noticia"
              src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Contratistas_Icon@3x.png"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{TitleHeader}}
          <div class="text-right" style=" margin-top: -10px; margin-right: -20px; float: right;">
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Descartar registro</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="remove()"
              >
                <mdb-icon icon="times" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>

        <!--/Card image-->

        <!--Card content-->
        <mdb-card-body>
          <form id="gateForm" class="needs-validation" novalidate @submit="submitForm">
            <mdb-row class="form-row">
              <!--Form content-->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Datos del registro</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="title"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Título</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="title"
                        required
                        maxlength="300"
                        minlength="3"
                        v-model="noticeTitle"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Asigna un Título</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label for="labelText" style="font-family: OpenSans-Semibold; font-size: 12px;">Descripción</label>
                      <textarea
                        class="form-control"
                        id="labelText"
                        rows="4"
                        maxlength="1500"
                        required
                        v-model="noticeDesc"
                      ></textarea>
                      <span
                        style="color: #a09c9c; margin-top: 0rem;"
                        class="limiter"
                      >{{characterRemaining}}/1500</span>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div
                      class="custom-control custom-checkbox"
                      style="margin-top: 0rem; padding-left: 0rem; margin-bottom: 16px;"
                    >
                      <input
                        type="checkbox"
                        class="form-control form-check-input"
                        id="defaultUnchecked"
                        v-model="allFrac"
                        @change="onSelect('allFrac')"
                      />
                      <label
                        class="form-check-label"
                        for="defaultUnchecked"
                      >Todos los residentes</label>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div
                      class="custom-control custom-checkbox"
                      style="margin-top: 0rem; padding-left: 0rem; margin-bottom: 16px;"
                    >
                      <input
                        type="checkbox"
                        class="form-control form-check-input"
                        id="checkboxAllZonesOneStreet"
                        v-model="allZonesOneStreet"
                        @change="onSelect('allZonesOneStreet')"
                      />
                      <label
                        class="form-check-label"
                        for="checkboxAllZonesOneStreet"
                      >Zona específica</label>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div
                      class="custom-control custom-checkbox"
                      style="margin-top: 0rem; padding-left: 0rem; margin-bottom: 16px;"
                    >
                      <input
                        type="checkbox"
                        class="form-control form-check-input"
                        id="checkboxSomeResidents"
                        v-model="someResidents"
                        @change="onSelect('someResidents')"
                      />
                      <label
                        class="form-check-label"
                        for="checkboxSomeResidents"
                      >Residentes seleccionados</label>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row v-if="!allFrac && allZonesOneStreet">
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Zona</label>
                      <model-select
                        :options="zonesList"
                        v-model="zoneModel"
                        style="height: 37px;"
                        placeholder="Selecciona una zona"
                        :isError="zoneValid"
                        :isDisabled="allFrac"
                      ></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row v-if="!allFrac && allZonesOneStreet">
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Calle</label>
                      <model-select
                        :options="streetList"
                        v-model="streetModel"
                        style="height: 37px;"
                        placeholder="Selecciona una calle"
                        :isError="streetValid"
                        :isDisabled="allFrac"
                      ></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row v-if="!allFrac && someResidents">
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Residente</label>
                      <div class="mt-lg-4 mb-1 pb-1">
                        <div>
                          <!-- Buscador -->
                          <div class="mt-lg-4 mb-1 pb-1 rectangulo_auto d-flex align-items-center" style="position: relative;">
                            <input
                              v-model="search"
                              @focus="showList = true"
                              class="filter-input flex-grow-1"
                              type="text"
                              placeholder="Buscar residente"
                            />
                            <mdb-icon icon="search" class="text-primary ml-2" />
                          </div>


                          <!-- Lista filtrada (solo si hay texto y showList está activo) -->
                          <ul v-if="showList && search.trim() !== ''" class="residents-list">
                            <li
                              v-for="residente in filteredResidentes"
                              :key="residente.uuid"
                              @click="selectResident(residente)"
                              class="residente-item"
                            >
                              {{ residente.name }}
                            </li>
                          </ul>

                          <!-- Seleccionados -->
                          <div v-if="selectedResidents.length >= 1" md="11" class="rectangulo_auto">
                            <mdb-card-body class="form">
                              <p
                                style="font-family: OpenSans-Bold; font-size: 14px; margin-bottom: -3%;"
                              >
                                Residentes seleccionados
                              </p>
                            </mdb-card-body>

                            <mdb-tbl
                              class="table_res_selec"
                              responsive
                              :scrollY="false"
                              maxHeight="400px"
                              style="font-family: OpenSans-Semibold; font-size: 12px; text-align: center;"
                            >
                              <mdb-tbl-body>
                                <tr v-for="(residente, index) in selectedResidents" :key="residente.uuid">
                                  <td style="font-size: 12px; font-family: OpenSans-Semibold;">
                                    {{ index + 1 }}
                                  </td>
                                  <td style="font-size: 12px; font-family: OpenSans-Semibold;">
                                    {{ residente.text }}
                                  </td>
                                  <td>
                                    <div style="display: flex">
                                      <!-- Botón de advertencia solo si alguna condición se cumple -->
                                      <button
                                        v-if="!residente.active || !residente.useapp || residente.hasRR"
                                        type="button"
                                        class="btn btn-warning btn-edit d-flex justify-content-center align-items-center"
                                        @click="showWarningResident(residente)"
                                        title="Advertencia"
                                      >
                                        <i class="fas fa-exclamation-triangle"></i>
                                      </button>
                                      <button
                                        type="button"
                                        class="btn btn-danger btn-edit d-flex justify-content-center align-items-center"
                                        @click="deleteResident(index, residente)"
                                      >
                                        <i class="far fa-trash-alt"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </mdb-tbl-body>
                            </mdb-tbl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="name"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre de contacto</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="name"
                        maxlength="300"
                        minlength="3"
                        v-model="nameContact"
                        style="height: 37px; font-size: 12px; width: 100%;"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="title"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Teléfono de contacto</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="title"
                        maxlength="300"
                        minlength="3"
                        v-model="phone"
                        style="height: 37px;  font-size: 12px; width: 100%;"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="email"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Correo de contacto</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="email"
                        maxlength="300"
                        minlength="3"
                        v-model="emailContact"
                        style="height: 37px; font-size: 12px; width: 100%;"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="urlContact"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Enlace de contacto</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="urlContact"
                        maxlength="300"
                        minlength="3"
                        v-model="urlContact"
                        style="height: 37px; font-size: 12px; width: 100%;"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                    <mdb-col md="11">
                      <div class="form-group">
                        <label
                          for="title"
                          style="font-family: OpenSans-Semibold; font-size: 12px"
                        >Fecha y hora de inicio</label>
                        <date-picker required v-model="dateStart" :config="isEdit ? optionsStart : options"></date-picker>
                        <!-- Botón Hoy -->
                        <!-- <button
                          type="button"
                          class="btn btn-sm btn-primary ml-2"
                          @click="setToday"
                        >
                          Hoy
                        </button> -->
                      </div>
                    </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="email"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Fecha y hora de término</label>
                      <date-picker :disabled="isDisabled" required v-model="dateEnd" :config="options2"></date-picker>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-col md="11">
                  <div class="form-group">
                    <mdb-row style="overflow: auto; padding-left: 10%;">
                      <div v-if="file_url==''">
                        <div>
                          <mdb-btn type="button" class="btn-Adjuntar btn-file">
                            <mdb-icon icon="paperclip" class="mt-0" />
                            <span style="font-size: 8px">Adjuntar imagen</span>
                            <input
                              type="file"
                              accept="image/jpeg, image/png"
                              name="file"
                              id="file"
                              @change="addPhoto"
                            />
                          </mdb-btn>
                        </div>
                      </div>
                      <div v-else class="imagen-contenedor">
                        <mdb-row>
                          <div>
                            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                              <span slot="tip">Eliminar archivo</span>
                              <mdb-btn
                                slot="reference"
                                type="button"
                                rounded
                                class="boton-eliminar"
                                @click="removeFile"
                              >
                                <mdb-icon icon="times" class="mt-0" />
                              </mdb-btn>
                            </mdb-tooltip>
                          </div>
                        </mdb-row>
                        <mdb-row>
                          <div class="embed-responsive" style="width: 22rem;">
                            <img alt="imagen noticia" :src="file_url" style="display: inline-block; width: 100%" />
                          </div>
                        </mdb-row>
                      </div>
                    </mdb-row>
                  </div>
                </mdb-col>
              </mdb-col>
            </mdb-row>
            <mdb-row class="justify-content-center">
              <mdb-col cols="auto" style="text-align: right;">
                <mdb-btn color="color-prev" type="button" class="btn-prev Rectngulo-14" @click="remove()">Cancelar</mdb-btn>
              </mdb-col>
              <mdb-col cols="auto" class="ms-3">
                <mdb-btn
                  v-if="TitleHeader=='Nuevo aviso'"
                  type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14"
                >Publicar</mdb-btn>
                <mdb-btn
                  v-else
                  type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14"
                >Actualizar</mdb-btn>
              </mdb-col>
              <!--Buttons content-->
            </mdb-row>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
    <Loader v-show="isLoading" />
  </mdb-container>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import "bootstrap/dist/css/bootstrap.css";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import Loader from "../../core/Loader";
import {
  mdbContainer,
  mdbTooltip,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn,
  mdbFormInline,
  mdbTbl,
  mdbTblHead,
  mdbTblBody
} from "mdbvue";
import moment from 'moment';
import { mapGetters, mapActions } from "vuex";

export default {
  name: "createNotice",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbFormInline,
    datePicker,
    ModelSelect,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Loader
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      TitleHeader: "Nuevo aviso",
      noticeTitle: "",
      noticeDesc: "",
      invalidResidents: [],
      showList: false,
      isLoading: false,
      allFrac: false,
      allZonesOneStreet: false,
      someResidents: false,
      selectedResidents: [],
      allResidentsList: [],
      search: "",
      nameContact: "",
      emailContact: "",
      phone: "",
      urlContact: "",
      zonesList: [],
      zoneModel: {
        value: "",
        uuid: "",
        text: ""
      },
      zoneValid: false,
      streetList: [],
      streetModel: {
        value: "",
        uuid: "",
        text: ""
      },
      streetValid: false,
      residentList: [],
      residentModel: {
        value: "",
        uuid: "",
        text: "",
        useapp: false,
        hasRR: false,
        active: true
      },
      residentValid: false,
      extensionFile: "",
      communityType: "",
      files: null,
      file_url: "",
      dateStart: null,
      dateEnd: null,
      options: {
        format: "YYYY-MM-DDTHH:mm:ss",
        useCurrent: true,
        useStrict: true,
        minDate: null,
        locale: "es",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar-alt",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
       options2: {
        format: "YYYY-MM-DDTHH:mm:ss",
        useCurrent: false,
        useStrict: false,
         minDate: "1900-01-30",
        locale: "es",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar-alt",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      optionsStart: {
        format: "YYYY-MM-DDTHH:mm:ss",
        useCurrent: false,
        useStrict: false,
         minDate: "1900-01-30",
        locale: "es",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar-alt",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      isDisabled: true,
    };
  },
  methods: {
    ...mapActions(["getAllResidentsBrief"]),
    async getResidentesBrief() {
      try {
        this.isLoading = true;
        let response = await this.getAllResidentsBrief();
        this.isLoading = false;
        this.allResidentsList = response.data;
      } catch (error) {
        this.isLoading = false;
        this.showMessageError("Error al obtener la lista de residentes");
      }
    },
    toggleResident(res) {
      // Buscar si ya está en selectedResidents por uuid
      const index = this.selectedResidents.findIndex(r => r.uuid === res.uuid);
      if (index !== -1) {
        // Si ya está, lo removemos
        this.selectedResidents.splice(index, 1);
      } else {
        // Si no está, lo agregamos completo
        this.selectedResidents.push({
          value: res.value,
          uuid: res.uuid,
          text: res.text,
          useapp: res.useapp,
          hasRR: res.hasOwnProperty("residentRegistration") ? true : false,
          active: res.hasOwnProperty("active") ? res.active : true,
        });
      }
    },
    onSelect(option) {
      // cuando seleccionas uno, apaga los otros
      if (option === 'allFrac' && this.allFrac) {
        this.allZonesOneStreet = false;
        this.someResidents = false;
      }
      if (option === 'allZonesOneStreet' && this.allZonesOneStreet) {
        this.allFrac = false;
        this.someResidents = false;
      }
      if (option === 'someResidents' && this.someResidents) {
        this.allFrac = false;
        this.allZonesOneStreet = false;
      }
    },
    setToday() {
        this.dateStart = moment();
    },
    async getOneNotice() {
      if (this.isEdit) {
        var data = this.comunity
        // Configuramos minDate para optionsStart
        const ahora = moment().startOf('day').toDate();
        const today = moment(); // hoy
        const dataStartDate = moment(data.startDate); // la fecha que recibes
        let minDateIni;
        if (today.format("YYYY-MM-DD") === dataStartDate.format("YYYY-MM-DD")) {
          // Si la fecha es igual a hoy, usamos hoy
          minDateIni = today.startOf("day"); 
        } else {
          // Si no, usamos dataStartDate
          minDateIni = dataStartDate;
        }

        //usando 'minDate'=minDateIni: Popup editable deja poner cualquier fecha desde el rango de la fecha de inicio
        //usando 'minDate'=ahora: Popup editable deja poner cualquier fecha desde hoy
        this.dateStart = data.startDate;
        this.optionsStart = {
          ...this.optionsStart,
          minDate: ahora
        };

        this.dateEnd = data.endDate
        this.TitleHeader = 'Editar aviso';
        this.noticeTitle = data.title
        this.noticeDesc = data.description
        this.nameContact = data.contactName
        this.phone = data.contactPhone
        this.emailContact = data.contactEmail
        this.urlContact = data.contactLink
        if (data && data.streets && data.streets.length > 0) {
          let resFirstStreet = await this.getResidentsByStreetUui(data.streets[0].uuid);
        }
        if(data.fileId){
          this.file_url = data.file.publicUrl
        }
        this.allFrac = !data.segmented
        this.allZonesOneStreet = false;
        this.someResidents = false;
        if (data.segmented) {
          let resFirstStreet = await this.getResidentsByStreetUui(data.streets[0].uuid);
          if (data.zones.length == 1 && data.streets.length == 1) {
            if (data.residents.length >= resFirstStreet.length) {
              this.allZonesOneStreet = true;
              this.someResidents = false;
              let foundOneZone = this.zonesList.filter(function(item){
                return item.uuid == data.zones[0].uuid
              })
        
              this.zoneModel = {
                value: foundOneZone[0].value,
                uuid: foundOneZone[0].uuid,
                text: foundOneZone[0].text
              }
              this.zoneValid = false;
              await this.getStreets(foundOneZone[0].uuid);
              let foundOneStreet = this.streetList.filter(function(item){
                return item.uuid == data.streets[0].uuid
              });
              this.streetModel = {
                value: foundOneStreet[0].value,
                uuid: foundOneStreet[0].uuid,
                text: foundOneStreet[0].text
              }
              this.streetValid = false;
            } else {
              this.allZonesOneStreet = false;
              this.someResidents = true;
            this.selectedResidents = data.residents.map((r, idx) => {
              return {
                value: r.idResident,
                uuid: r.uuid,
                text: r.name !== "null null" ? r.name : "Sin nombre",
                useapp: r.useapp,
                hasRR: r.hasOwnProperty("residentRegistration") ? true: false,
                active: r.hasOwnProperty("active") ? r.active : true,
              };
            });
            this.residentValid = false;
            }
          } else {
            this.allZonesOneStreet = false;
            this.someResidents = true;
            this.selectedResidents = data.residents.map((r, idx) => {
              return {
                value: r.idResident,
                uuid: r.uuid,
                text: r.name !== "null null" ? r.name : "Sin nombre",
                useapp: r.useapp,
                hasRR: r.hasOwnProperty("residentRegistration") ? true : false,
                active: r.hasOwnProperty("active") ? r.active : true,
              };
            });
            this.residentValid = false;
          }
        }
      } else {
        this.setToday()
      }
    },
    remove() {
      var obj = [];
      this.$store.commit("cm/setComunity", obj);
      this.$store.commit("cm/setEdit", false);
      // Avisar al store que se debe recargar la lista
      this.$store.commit('cm/setReloadNotices', true);
      window.location.href = "/notices";
    },
    removeFile() {
      this.files = null;
      this.file_url = "";
      this.extensionFile = "";
      this.communityType = "";
    },
    addPhoto: function(evt) {
      this.file_url = URL.createObjectURL(evt.target.files[0]);
      this.communityType = evt.target.files[0].type;
      this.extensionFile = evt.target.files[0].name.split(".")[1];
      let aux = this;
      var img = new Image();
      img.src = URL.createObjectURL(evt.target.files[0]);
      img.onload = function() {
        var rdr = new FileReader();
        rdr.onload = function(e) {
          aux.files = e.target.result.split(",")[1];
        };
        rdr.readAsDataURL(evt.target.files[0]);
      };
    },
    showWarningResident(residente) {
      let aux = this;
      aux.showMessageWarning(`El residente <b>${residente.text}</b>  no será incluido, verifica su registro.`);
    },
    selectResident(residente) {
      let aux = this;
      const exists = this.selectedResidents.some(r => r.uuid === residente.uuid);
      if (!exists) {
        if (residente.useapp === true && (residente.active === undefined || residente.active === true) && (residente.residentRegistration === undefined || residente.hasRR === false)) {
          // Todo bien, se agrega a selectedResidents
          this.selectedResidents.push({
            value: residente.value,
            uuid: residente.uuid,
            text: residente.name,
            useapp: residente.useapp,
            hasRR: residente.hasOwnProperty("residentRegistration") ? true : false,
            active: residente.hasOwnProperty("active") ? residente.active : true,
          });
          //aux.showMessageWarning(`${JSON.stringify(residente)}`);
        } else {
          aux.showMessageWarning(`El residente <b>${residente.name}</b> no será incluido, verifica su registro.`);
        }


      } else {
        aux.showMessageWarning(`El residente <b>${residente.name}</b>, ya está en la lista`);
      }

      // Limpiar búsqueda y cerrar lista
      this.search = "";
      this.showList = false;
    },
    deleteResident(index, residente) {
      this.selectedResidents.splice(index, 1);
    },
    submitForm(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");

      // Reset de validaciones
      this.zoneValid = false;
      this.streetValid = false;
      this.residentValid = false;

      // -------- Validaciones obligatorias comunes --------
      const obligatorioOk =
        this.noticeTitle &&
        this.noticeDesc &&
        this.dateStart &&
        this.dateEnd;

      if (!obligatorioOk) {
        this.showMessageError('Faltan campos obligatorios (título, descripción o fechas).');
        return;
      }

      // -------- Construcción base del data --------
      let data = {
        title: this.noticeTitle,
        description: this.noticeDesc,
        contactName: this.nameContact,
        contactPhone: this.phone,
        contactEmail: this.emailContact,
        contactLink: this.urlContact,
        startDate: this.dateStart,
        endDate: this.dateEnd,
        segmented: !this.allFrac,
      };

      // -------- Caso 1: allFrac --------
      if (this.allFrac) {
        // no se agregan zones, streets ni residents
      } else if (this.allZonesOneStreet) {
        // -------- Caso 2: allZonesOneStreet --------
        if (!this.zoneModel?.value) {
          this.zoneValid = true;
          this.showMessageError('Zona no seleccionada.');
          return;
        }
        if (!this.streetModel?.value) {
          this.streetValid = true;
          this.showMessageError('Calle no seleccionada.');
          return;
        }
        data.zones = [{
          idZone: this.zoneModel.value,
          uuid: this.zoneModel.uuid
        }];
        data.streets = [{
          idStreet: this.streetModel.value,
          uuid: this.streetModel.uuid
        }];

      } else if (this.someResidents) {
        // -------- Caso 3: someResidents --------
        if (!this.selectedResidents || this.selectedResidents.length === 0) {
          this.residentValid = true;
          this.showMessageError('No hay residentes seleccionados.');
          return;
        }
        // Validar residentes
        this.invalidResidents = this.selectedResidents.filter(r => {
          return !(r.useapp === true && r.active === true && r.hasRR === false);
        });

        if (this.invalidResidents.length > 0) {
          this.residentValid = true;
          this.selectedResidents = this.selectedResidents.filter(r =>
            r.useapp === true && r.active === true && r.hasRR === false
          );
        }
        if (this.selectedResidents.length === 0) {
          this.showMessageError('Se eliminaron los residentes con el ícono <span><i class="fas fa-exclamation-triangle" style="color: #ffc107;"></i></span> y no quedaron residentes seleccionados.');
          return;
        }
        data.residents = this.selectedResidents.map(r => ({
          idResident: r.value,
          uuid: r.uuid,
          name: r.text
        }));
      } else {
        this.showMessageError('Selecciona a quiénes deseas que les llegue este aviso.');
        return;
      }

      // -------- Caso archivos --------
      if (this.files) {
        const uuid = this.comunity?.uuid || this.uuidv4(); // genera o usa el uuid
        data.file = {
          uuid: uuid,
          name: uuid,
          extension: this.extensionFile,
          mimeType: this.communityType,
          content: this.files
        };
      }
      // -------- Decisión final PUT o POST --------
      if (this.isEdit) {
        this.putNotices(data);
      } else {
        this.postNotices(data);
      }
    },
    putNotices(data) {
      let aux = this;
      Axios.put(Servers.serverApi + "api/notices/" + aux.comunity.uuid, data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
      .then((response) => {
        if (aux.invalidResidents && aux.invalidResidents.length >= 1) {
          aux.showMessageError(
            'Aviso actualizado correctamente.<br>Los residentes con el ícono <span><i class="fas fa-exclamation-triangle" style="color: #ffc107;"></i></span> fueron descartados.'
          );
        } else {
          aux.showMessageSucces("Aviso actualizado correctamente");
        }
      })
      .catch((error) => {
        const msg = error.response?.data || error.message || "Error desconocido en el servidor";
        aux.showMessageError(`Error en PUT: ${msg}`);
      })
      .finally(() => {
        this.$emit('notice-updated');
      });
    },
    postNotices(data) {
      let aux = this;
      Axios.post(Servers.serverApi + "api/notices", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
      .then((response) => {
        if (aux.invalidResidents && aux.invalidResidents.length >= 1) {
          aux.showMessageError(
            'Aviso creado correctamente.<br>Los residentes con el ícono <span><i class="fas fa-exclamation-triangle" style="color: #ffc107;"></i></span> fueron descartados.'
          );
        } else {
          aux.showMessageSucces("Aviso creado correctamente");
        }
      })
      .catch((error) => {
        const msg = error.response?.data || error.message || "Error desconocido en el servidor";
        aux.showMessageError(`Error en POST: ${msg}`);
      })
      .finally(() => {
        aux.$emit("notice-created");
      });
    },
    async getZones() {
      
      let response = await Axios.get(Servers.serverApi + "api/zones", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      });
      this.zonesList = [];
        for (var i = 0; i < response.data.length; i++) {
          var temp = {
            value: response.data[i].idZone,
            uuid: response.data[i].uuid,
            text: response.data[i].name
          };
          this.zonesList.push(temp);
        }
      this.getOneNotice();
    },
    async getStreets(zoneUuid) {
      let response = await Axios.get(Servers.serverApi + "api/streets/zones/" + zoneUuid, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
      this.streetList = [];
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idStreet,
              uuid: response.data[i].uuid,
              text: response.data[i].name
            };
            this.streetList.push(temp);
          }
      return this.streetList;
    },
   async getResidentsByStreetUui(streetUuid) {
    
      let response = await Axios.get(Servers.serverApi + "api/residents/streets/" + streetUuid, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })

       this.residentList = [];
          ;
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idResident,
              uuid: response.data[i].uuid,
              text: response.data[i].firstName + " " + response.data[i].lastName

            };
            this.residentList.push(temp);
          }
          return this.residentList; 
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    showMessageError: function(text) {
      Swal.fire({
        html: `
          <div style="text-align: center;">
            <span style="font-size: 40px; color: #DC3545; font-weight: bold;">✖</span>
            <div style="font-size: 20px; font-family: OpenSans-Semibold; margin-top: 5px;">Error</div>
            <div style="font-size: 12px; margin-top: 10px;">${text}</div>
          </div>
        `,
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          this.remove();
        }
      });
    },
    showMessageWarning: function(text) {
      Swal.fire({
        html: `
          <div style="text-align: center;">
            <span style="font-size: 40px; color: #FFC107; font-weight: bold;">!</span>
            <div style="font-size: 20px; font-family: OpenSans-Semibold; margin-top: 5px;">Advertencia</div>
            <div style="font-size: 12px; margin-top: 10px;">${text}</div>
          </div>
        `,
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    }
  },
  async created() {
    await this.getResidentesBrief();
    await this.getZones();
  },
  beforeDestroy() {
    this.remove(); // limpia el store antes de que el componente se destruya
  },
  computed: {
    isEdit() {
      return this.$store.state.cm.edit;
    },
    comunity() {
      return this.$store.state.cm.comunityObject;
    },
    characterRemaining: function() {
      return this.noticeDesc.length;
    },
    filteredResidentes() {
      const term = (this.search || "").toLowerCase();
      return this.allResidentsList.filter(r => {
        const name = (r.name || "").toLowerCase();
        return name.includes(term);
      });
    }
  },
  watch: {
    zoneModel(newZone) {
      this.zoneModel = newZone;
      this.residentModel = null;
      this.residentList = [];
      this.selectedResidents = [];
      if (newZone.value) {
        this.zoneValid = false;
        this.getStreets(newZone.uuid);
      } else {
        this.zoneValid = true;
      }
    },
    streetModel(newStreet) {
      this.streetModel = newStreet;
      this.selectedResidents = [];
      if (newStreet.value) {
        this.streetValid = false;
      } else {
        this.streetValid = true;
      }
    },
    residentModel(newResident) {
      // Solo válido si hay lista de residentes
      if (this.residentList && this.residentList.length > 0) {
        this.residentValid = !newResident || !newResident.value; // true si está vacío
      } else {
        this.residentValid = true; // no hay lista, siempre inválido
      }
    },
    allFrac(value) {
      this.allFrac = value;
      if (value) {
        this.zoneValid = this.streetValid = this.residentValid = false;
      }
    },
     dateStart(value){
      if(value){
        this.isDisabled = false
        this.$set(this.options2, 'minDate', value)
      }
      else{
        this.isDisabled = true
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn_background {
  background-color: #ed5f5f !important;
  object-fit: contain;
  width: 31.2px;
}
</style>
<style scoped>
.btn-Adjuntar {
  width: 10rem !important;
  height: 5rem !important;
  border-radius: 6px !important;
  border: solid 1px #1a8a68 !important;              /* Verde más claro y fresco */
  background-color: #28a187 !important;              /* Fondo más amigable */
  color: rgb(255, 255, 255) !important;                           /* Para mejor contraste */
  transition: background-color 0.3s ease, filter 0.3s ease;
}

.btn-Adjuntar:hover,
.btn-Adjuntar:active,
.btn-Adjuntar.clicked {
  background-color: #218f77 !important;              /* Un tono más oscuro al hacer hover */
  filter: brightness(95%);
  color: white !important;
}

.btn-file {
  overflow: hidden;
  position: relative;
}
.btn-file input[type="file"] {
  cursor: inherit;
  display: block;
  font-size: 100px;
  min-height: 100%;
  min-width: 100%;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;
}

.previewImg {
  position: initial;
  z-index: 0;
}

.imagen-contenedor {
  width: 22rem;
}

.boton-eliminar {
  position: absolute;
  top: 0rem;
  left: 0.7rem;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8); /* fondo opcional para visibilidad */
  border-radius: 50%;
  padding-top: 5px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
}

.list-box {
  background: #fff;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}

li {
  margin: .3rem 0;
  padding: .4rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;
}

li:hover {
  background: #f0f0f0;
}

li.selected {
  background: #007bff;
  color: white;
}

.selected-input {
  width: 100%;
  padding: .5rem;
  margin-bottom: .8rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #f1f1f1;
  min-height: 2.3rem;
}

.residents-list {
  position: absolute;
  width: 100%;
  background: #fff;
  border: 1px solid #ccc;
  max-width: 275px;
  overflow-y: auto;
  overflow-x: auto;
  z-index: 1000;
  list-style: none;
  padding: 0;
  box-sizing: border-box;
  white-space: nowrap;
}

.residente-item {
  padding: 8px 12px;
  cursor: pointer;
}

.residente-item:hover {
  background: #f0f0f0;
}

.rectangulo_auto {
  width: auto;
  height: auto;
  border-radius: 25px;
  border: 2px solid #bce0fd; /* borde azul */
  background-color: #fff;
  padding: 5px 10px;
}

.filter-input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
}

.card-body {
  padding: .5rem;
}

.table_res_selec td {
  padding: 2px 6px !important;
  align-content: center;
}
</style>
